/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { RenderTableAttributeInput } from './RenderTableAttributeInput';
import type { RenderTableFilterInput } from './RenderTableFilterInput';
import type { RenderTableGroupInput } from './RenderTableGroupInput';
import type { RenderTableOrderInput } from './RenderTableOrderInput';

export type RenderTableInput = {
    /**
     * Optional saved dashboard view id. When provided, Lumonic renders that persisted view directly.
     */
    view_id?: (string | null);
    /**
     * Primary namespace id or name for manual table rows, for example Borrower or cltr-...::ENTITY.
     */
    namespace?: (string | null);
    /**
     * snapshot returns rows as of a date; time_series returns one row per row/date tuple.
     */
    view_type?: RenderTableInput.view_type;
    /**
     * entity returns entity rows, groups returns grouped rows, total returns one aggregate row.
     */
    row_grain?: RenderTableInput.row_grain;
    /**
     * Snapshot date in YYYY-MM-DD or Lumonic relative date format. Required when date_strategy=exact.
     */
    effective_date?: (string | null);
    /**
     * For snapshot views, latest allows carry-forward/latest source data; exact requires the date.
     */
    date_strategy?: RenderTableInput.date_strategy;
    /**
     * Time-series start date in YYYY-MM-DD or relative date format.
     */
    start_date?: (string | null);
    /**
     * Time-series end date in YYYY-MM-DD or relative date format.
     */
    end_date?: (string | null);
    /**
     * Optional display cadence fallback for cashflow performance metrics in time_series views. Supported values: m, q, fq, y, fy, or ltm. For financial fields, put cadence in the LX expression instead, for example `@company.revenue[period=m::q]`.
     */
    cadence?: ('m' | 'q' | 'fq' | 'y' | 'fy' | 'ltm' | null);
    /**
     * Optional root entity scope. Omit for cluster-level portfolio tables.
     */
    entity_id?: (string | null);
    /**
     * Output column objects with `expression` plus optional id/name, return_type, aggregate, and namespace.
     */
    attributes?: Array<RenderTableAttributeInput>;
    /**
     * Filter objects. Use expression filters for LX booleans or cashflow_tag filters for tag categories.
     */
    filters?: Array<RenderTableFilterInput>;
    /**
     * Sort objects with LX `expression` and optional `direction`.
     */
    orders?: Array<RenderTableOrderInput>;
    /**
     * Group objects for row_grain=groups, using expression, date, or cashflow_tag group types.
     */
    groups?: Array<RenderTableGroupInput>;
    /**
     * Defaults to 50 for snapshot and 20 for time_series. Maximum 500.
     */
    limit?: (number | null);
    /**
     * When truncated or limited, include non-null counts per output attribute.
     */
    include_coverage?: boolean;
    /**
     * When true, include explicit renderer route and compiled view details.
     */
    debug?: boolean;
};

export namespace RenderTableInput {

    /**
     * snapshot returns rows as of a date; time_series returns one row per row/date tuple.
     */
    export enum view_type {
        SNAPSHOT = 'snapshot',
        TIME_SERIES = 'time_series',
    }

    /**
     * entity returns entity rows, groups returns grouped rows, total returns one aggregate row.
     */
    export enum row_grain {
        ENTITY = 'entity',
        GROUPS = 'groups',
        TOTAL = 'total',
    }

    /**
     * For snapshot views, latest allows carry-forward/latest source data; exact requires the date.
     */
    export enum date_strategy {
        LATEST = 'latest',
        EXACT = 'exact',
    }


}

